export default __webpack_public_path__ + "static/Visiomate_BJF_Case_Study-c13570e8b8be9edd49d2385ea5ae5a57.pdf";